(function () {
  var SELECTOR = '[data-header-wrapper][data-header-hide-on-scroll]';
  var STUCK = 'js__header__stuck';
  var HIDDEN = 'js__header__hidden';
  var MEGANAV_OPEN = 'meganav--visible';

  function onScroll(e) {
    var header = document.querySelector(SELECTOR);
    if (!header) return;

    if (!header.classList.contains(STUCK)) {
      if (header.classList.contains(HIDDEN)) header.classList.remove(HIDDEN);
      return;
    }

    if (document.documentElement.hasAttribute('data-scroll-locked')) return;
    if (header.classList.contains(MEGANAV_OPEN)) return;

    if (e.detail.down) {
      header.classList.add(HIDDEN);
    } else if (e.detail.up) {
      header.classList.remove(HIDDEN);
    }
  }

  document.addEventListener('theme:scroll', onScroll);
})();
